module.exports = __webpack_public_path__ + "static/media/Like.8d21ef2b.svg";